import { withInstall } from "../../utils";
import Radio from "./src/radio.vue";

export const IRadio = withInstall(Radio); // 增加类型

export default IRadio;
